// extracted by mini-css-extract-plugin
export var bannerWrapper = "index-module--bannerWrapper--qrjdo";
export var btn1 = "index-module--btn1--VSEC1";
export var btn2 = "index-module--btn2--sA+y1";
export var buttons = "index-module--buttons--Hxyjo";
export var content = "index-module--content--u4ys2";
export var des = "index-module--des--6BwEs";
export var title = "index-module--title--S+IIJ";